import * as React from 'react';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import ListItemContent from '@mui/joy/ListItemContent';
import Typography from '@mui/joy/Typography';
import { useTheme } from '@mui/joy/styles';
import { CustomDimensions } from 'styles/theme/themes';
import { Link } from 'react-router-dom';

interface SidebarItemProps {
  onClick?: () => void;
  text: string;
  href?: string;
  icon: React.ReactNode;
  isSidebarOpen: boolean;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  onClick,
  href,
  text,
  icon,
  isSidebarOpen,
}) => {

  const ComponentItem = (

    <ListItemButton
      onClick={onClick}
      sx={{
        height: '100%',
        px: 2,
        borderRadius: theme => CustomDimensions.cornerRadius,
        '& .MuiSvgIcon-root': {
          color: theme => theme.vars.palette.neutral[400],
          transition: 'color 0.2s ease-in-out',
          fontSize: CustomDimensions.iconSize,
        },
        '&:hover .MuiSvgIcon-root': {
          color: theme => theme.vars.palette.neutral[600],
          transform: 'scale(1.05)',
        },
        '& .MuiTypography-root': {
          color: theme => theme.vars.palette.neutral[500],
          transition: 'color 0.2s ease-in-out',
        },
        '&:hover .MuiTypography-root': {
          color: theme => theme.vars.palette.neutral[700],
        },
      }}
    >
      {icon}
      <ListItemContent
        sx={{
          // display: isSidebarOpen ? 'none' : 'block',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
      >
        <Typography
          // level="title-md"
          sx={{
            fontWeight: 600,
            fontFamily: 'Open Sans',
          }}
        >
          {text}
        </Typography>
      </ListItemContent>
    </ListItemButton>
  )

  return (
    <ListItem sx={{ height: '60px' }}>
      {
        href ?
          <Link to={href} style={{width: '100%', height: '100%'}}>
            {ComponentItem}
          </Link>
          :
          ComponentItem
      }
    </ListItem>
  );
};

export default SidebarItem;
